import { createStructuredSelector } from 'reselect'

const licenseInstaller = ({ licenseInstaller }) => licenseInstaller

export default createStructuredSelector({
  licenseInstaller
})
